import timeFormAPI from '../../api/ui/timeFormAPI';
import {create} from './table-schema';
import useTranslation from '../../hooks/useTranslation';
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import changeNumApi from "../../api/ui/changeNumApi";
import {convertBigNumToDecimalString} from "../../utils/convert-decimal-to-big-num";
import {convertFalsyToHyphen} from "../../constants/base";

function useSchemaMonitoringNftCarDataLevel() {
    const {t} = useTranslation();
    const locale = useSelector((state) => state.language.locale);


    /**
     * 테이블 헤더에 표시할 항목 문자열 배열
     */
    const headerKeys = [
        "날짜",
        "1 ~ 100",
        "101 ~ 200",
        "201 ~ 300",
        "301 ~ 400",
        "401 ~ 500",
        "501 ~ 600",
        "601 ~ 700",
        "701 ~ 800",
        "801 ~ 900",
        "901 ~ 1000",
        "1000 이상"
    ];


    /**
     * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
     *
     * 오브젝트 키는 param1, param10 등의 형식으로 param 다음에 숫자를 붙여서 사용한다.
     *
     * param1은 헤더의 첫번째 표시되는 항목이다.
     *
     * 헤더에는 표시되지 않지만 상세에 표시될 항목의 경우 headSize 이후의 숫자를 사용한다.
     *
     * key는 반드시 있어야 한다.
     * @param {object} row
     * @returns
     */
    const parse = (row) => {

        const id = row?.index;
        const date = row?.time;

        const stat1to100 = row["01"];
        const stat101to200 = row["10"];
        const stat201to300 = row["20"];
        const stat301to400 = row["30"];
        const stat401to500 = row["40"];
        const stat501to600 = row["50"];
        const stat601to700 = row["60"];
        const stat701to800 = row["70"];
        const stat801to900 = row["80"];
        const stat901to1000 = row["90"];
        const over = row["over"];


        return {
            key: id, // 키는 반드시 있어야 한다.
            param1: date,
            param2: convertFalsyToHyphen(stat1to100),
            param3: convertFalsyToHyphen(stat101to200),
            param4: convertFalsyToHyphen(stat201to300),
            param5: convertFalsyToHyphen(stat301to400),
            param6: convertFalsyToHyphen(stat401to500),
            param7: convertFalsyToHyphen(stat501to600),
            param8: convertFalsyToHyphen(stat601to700),
            param9: convertFalsyToHyphen(stat701to800),
            param10: convertFalsyToHyphen(stat801to900),
            param11: convertFalsyToHyphen(stat901to1000),
            param12: convertFalsyToHyphen(over)
        };
    };

    /**
     * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
     *
     * 입력값인 row는 위의 parse에서 변환된 값이다.
     *
     * @param {object} row
     * @returns
     */
    const details = (row) => {
        const array = [];
        if (row) {
            //
        }
        return array;
    };

    const [schema, setSchema] = useState();

    useEffect(() => {
        const headers = headerKeys.map((key) => t(key));
        const schema = create({
            heads: headers,
            parseFunc: parse,
            detailFunc: details,
        });
        setSchema(schema);
    }, [locale]);

    return schema;
}

export default useSchemaMonitoringNftCarDataLevel;
